/**
 * 统一 HTTP 请求（网关 feifan-xxl-art，自动附带 Authorization）
 */

import { getAuthHeaders } from '@/utils/authToken';
import {
  HttpError,
  createHttpError,
  notifyHttpError,
  setHttpErrorNotifier,
} from '@/services/httpErrorHandler';

export { HttpError, setHttpErrorNotifier } from '@/services/httpErrorHandler';

export const BASE_URL = (import.meta.env.VITE_API_BASE_URL || 'https://xxl-gateway-daily.1605ai.com/feifan-xxl-art').replace(/\/$/, '');
const pendingGetRequests = new Map();

function serializeHeaders(headers) {
  return Object.entries(headers || {})
    .map(([key, value]) => [String(key).toLowerCase(), String(value)])
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([key, value]) => `${key}:${value}`)
    .join('|');
}

function rejectRequestError(error, { silentError, url }) {
  notifyHttpError(error, { silent: silentError, url });
  throw error;
}

export async function request(url, options = {}) {
  const {
    skipAuth = false,
    params,
    headers: optionHeaders,
    dedupe = true,
    silentError = false,
    ...fetchOptions
  } = options;
  const isFormData = fetchOptions.body instanceof FormData;

  let requestUrl = url;
  if (params && typeof params === 'object') {
    const search = new URLSearchParams(
      Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
    );
    const query = search.toString();
    if (query) {
      requestUrl += (url.includes('?') ? '&' : '?') + query;
    }
  }

  const headers = getAuthHeaders({
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...optionHeaders,
  });

  if (skipAuth) {
    delete headers.Authorization;
  }

  const config = {
    ...fetchOptions,
    headers,
  };

  if (config.body && typeof config.body === 'object' && !isFormData) {
    config.body = JSON.stringify(config.body);
  }

  const method = String(config.method || 'GET').toUpperCase();
  const requestKey = `${method}:${requestUrl}:${serializeHeaders(headers)}`;
  const canDedupe = dedupe && method === 'GET' && !config.signal;
  const fullUrl = `${BASE_URL}${requestUrl}`;

  if (canDedupe && pendingGetRequests.has(requestKey)) {
    return pendingGetRequests.get(requestKey);
  }

  const task = (async () => {
    try {
      const response = await fetch(fullUrl, config);
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        rejectRequestError(createHttpError(data, response, fullUrl), { silentError, url: fullUrl });
      }

      if (data.success === false) {
        rejectRequestError(createHttpError(data, response, fullUrl), { silentError, url: fullUrl });
      }

      return data;
    } catch (error) {
      if (error instanceof HttpError) throw error;

      const networkError = new HttpError(error?.message || '网络请求失败，请检查网络连接', {
        url: fullUrl,
      });
      rejectRequestError(networkError, { silentError, url: fullUrl });
    }
  })();

  if (!canDedupe) return task;
  pendingGetRequests.set(requestKey, task);
  try {
    return await task;
  } finally {
    if (pendingGetRequests.get(requestKey) === task) pendingGetRequests.delete(requestKey);
  }
}
